<div class="bulbs">
    <div
        class="bulb"
        *ngFor="let indicator of indicatorColors"
        [ngStyle]="{ 'background-color': points >= indicator.at ? indicator.color : '#E8EAEE' }"></div>
</div>
